import type { ReactNode, ReactElement } from 'react';

import { useState } from 'react';

import useClassy from '@core/hooks/useClassy';
import Flex from '@ui/Flex';
import Icon from '@ui/Icon';

import classes from './style.module.scss';

interface GroupProps {
  children: ReactNode;
  sectionHeader?: {
    badge: ReactElement | null;
    label: string | null;
  };
}

const Group = ({ children, sectionHeader }: GroupProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const bem = useClassy(classes, 'Sidebar');

  // Handle groups without a label or icon
  if (sectionHeader === null) {
    return <>{children}</>;
  }

  return (
    <div
      className={bem(
        '-group',
        'rm-Sidebar-group',
        'reference-redesign',
        'rm-Sidebar',
        classes.Sidebar,
        classes.Sidebar_sidebarLayout,
      )}
    >
      <button
        className={bem(
          'Sidebar-group-toggle',
          isExpanded && 'Sidebar-group-toggle_expanded',
          'rm-Sidebar-group-toggle',
        )}
        onClick={() => setIsExpanded(!isExpanded)}
        type="button"
      >
        <Flex align="center" gap="sm">
          {sectionHeader?.badge}
          <span>{sectionHeader?.label}</span>
        </Flex>
        <Icon aria-hidden="true" className={bem('-link-icon')} name={isExpanded ? 'chevron-down' : 'chevron-right'} />
      </button>
      {!!isExpanded && <ul className={bem('Sidebar-group-list', 'rm-Sidebar-group-list')}>{children}</ul>}
    </div>
  );
};

export default Group;
